module.exports = __webpack_public_path__ + "41a344fb180cacbb07a861d22ae87bca.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/Graphik-Semibold.ttf
// module id = 428
// module chunks = 0